import classNames from "classnames";

export const wrapper = classNames(
    // Mobile
    // Tablet
    // All
    "px-6",
    "py-8",
    "bg-[#F1F2F4]"
)

export const heading = classNames(
    // Mobile
    "mobile:mt-0",
    "mobile:mb-2",
    "mobile:mx-auto",
    // Tablet
    // All
    "text-[40px]",
    "border-b-2",
    "border-[#04A9F4]",
    "text-center",
    "w-fit"

    // "flex",
    // "flex-col",
    // "items-center",
    // "justify-center",
)
